import { AdContract as AdContractAPI } from '@/api/api';
import {
  AD_CONTRACT,
  ACCEPT_AD_CONTRACT,
  HAS_SEEN_CONTRACT,
  RESET,
} from '../../types';

// values should be falsy
// use null over an empty array or object
// so that we can check them directly within the if conditions
// to find out if we have already fetched the data or not
export const state = () => ({
  isAccepted: null,
  hasSeen: false,
});

export const getters = {
  [AD_CONTRACT]({ isAccepted }) {
    return isAccepted;
  },
  [HAS_SEEN_CONTRACT]({ hasSeen }) {
    return hasSeen;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [AD_CONTRACT](stateObj, isAccepted) {
    stateObj.isAccepted = isAccepted;
  },

  [ACCEPT_AD_CONTRACT](stateObj) {
    stateObj.isAccepted = true;
  },

  [HAS_SEEN_CONTRACT](stateObj, hasSeen) {
    stateObj.hasSeen = hasSeen;
  },

  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [AD_CONTRACT]({ commit, state }) {
    if (state.isAccepted !== null) return Promise.resolve();

    return AdContractAPI.getStatus()
      .then(({ accepted }) => {
        commit(AD_CONTRACT, accepted);
      })
      .catch(() => {});
  },
  [ACCEPT_AD_CONTRACT]({ commit }) {
    commit(ACCEPT_AD_CONTRACT);
  },
  [HAS_SEEN_CONTRACT]({ commit }, hasSeen) {
    commit(HAS_SEEN_CONTRACT, hasSeen);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
